<template>
    <div class="catering__form">
        <div ref="bgYellow" class="catering__bg-yellow"></div>
        <div ref="bgWhite" class="catering__bg-white"></div>

        <!-- π ----
        // :: LOCATION
        // : ---------------------------------- -->
        <div class="catering__address">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 ref="title" class="u-text-align-center">
                            {{ addressTitle }}
                        </h3>
                        <div ref="text" class="catering__text u-text-color-grey">
                            {{ addressText }}
                        </div>

                        <div class="catering__address-form" ref="input">
                            <input type="text" v-model="eventAddress" placeholder="address"
                                class="catering__input catering__input--full" />
                            <input type="text" v-model="eventCity" placeholder="city" class="catering__input
                            catering__input--1/2" />

                            <input type="text" v-model="eventState" placeholder="state"
                                class="catering__input catering__input--1/4" />
                            <input type="text" v-model="eventZip" placeholder="zip"
                                class="catering__input catering__input--1/4" />
                        </div>

                        <div class="catering__form-foot" ref="button">
                            <button @click="stageForm(defaultEmail)" class="catering__link-02">
                                Don't have an event address yet?
                            </button>
                            <button @click="checkForm()" class="catering__link">Next Step</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- π ----
        // :: FORM
        // : ---------------------------------- -->
        <iframe v-if="formReady" ref="form" id="typeform-full" class="catering__typeform" width="100%" height="100%"
            frameborder="0" :src="updatedForm"></iframe>

        <!-- π ----
        // :: FORM COVER
        // : ---------------------------------- -->
        <div v-show="loadForm" ref="cover" class="catering__cover"></div>

        <!-- π ----
        // :: CLOSE
        // : ---------------------------------- -->
        <div ref="closeButton" class="catering__close">
            <button @click="close()">
                <svg viewBox="0 0 30 29">
                    <path d="M26.314 25.814L15 14.5 3.686 3.186m22.628 0L15 14.5 3.686 25.814" stroke="#ffffff"
                        stroke-width="4" fill="none" stroke-linecap="square" />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>

import {Circ, gsap, Power1, Power2} from 'gsap';
export default {
    props: ['addressTitle', 'addressText', 'typeform', 'defaultEmail'],

    data() {
        return {
            animating: false,
            addressFull: '',
            eventAddress: '',
            eventCity: '',
            eventState: 'GA',
            eventZip: '',
            formReady: false,
            loadForm: false,
            updatedForm: null,
            errors: false,
            selectedRegion: null,

            gustoRegions: [
                {
                    title: 'peachtree',
                    id: 145,
                    regionBounds: null,
                    coordinates: [
                        { lng: -84.3975245, lat: 33.8432466 },
                        { lng: -84.4315601, lat: 33.8532634 },
                        { lng: -84.4549061, lat: 33.8696919 },
                        { lng: -84.4816416, lat: 33.8579902 },
                        { lng: -84.5076853, lat: 33.8531251 },
                        { lng: -84.566636, lat: 33.8570605 },
                        { lng: -84.5667779, lat: 33.8027305 },
                        { lng: -84.5182103, lat: 33.7425107 },
                        { lng: -84.4531577, lat: 33.7678251 },
                        { lng: -84.4526974, lat: 33.8123231 },
                        { lng: -84.4200817, lat: 33.8120379 },
                        { lng: -84.4135586, lat: 33.8049061 },
                        { lng: -84.398109, lat: 33.8006269 },
                        { lng: -84.3929592, lat: 33.7949208 },
                        { lng: -84.3912575, lat: 33.7882367 },
                        { lng: -84.3911006, lat: 33.7818019 },
                        { lng: -84.3686242, lat: 33.7817859 },
                        { lng: -84.3406315, lat: 33.7958416 },
                        { lng: -84.3390051, lat: 33.8127061 },
                        { lng: -84.3389158, lat: 33.8127154 },
                        { lng: -84.3588299, lat: 33.8209856 },
                        { lng: -84.3356557, lat: 33.8320017 },
                        { lng: -84.3586005, lat: 33.8526919 },
                        { lng: -84.3574843, lat: 33.8596412 },
                        { lng: -84.3818614, lat: 33.85419 },
                        { lng: -84.3975245, lat: 33.8432466 }
                    ]
                },

                {
                    title: 'chamblee',
                    id: 140,
                    regionBounds: null,
                    coordinates: [
                        { lng: -84.3544802, lat: 33.9554162 },
                        { lng: -84.3524207, lat: 33.8903195 },
                        { lng: -84.3586005, lat: 33.8526919 },
                        { lng: -84.3356557, lat: 33.8320017 },
                        { lng: -84.3068977, lat: 33.8430179 },
                        { lng: -84.2700233, lat: 33.848415 },
                        { lng: -84.1968955, lat: 33.8732181 },
                        { lng: -84.0978609, lat: 33.8712183 },
                        { lng: -84.0983566, lat: 33.9307603 },
                        { lng: -84.1066893, lat: 33.9858106 },
                        { lng: -84.1082343, lat: 33.9996162 },
                        { lng: -84.2126884, lat: 33.9871625 },
                        { lng: -84.331551, lat: 33.9615195 },
                        { lng: -84.3544802, lat: 33.9554162 }
                    ]
                },

                {
                    title: 'ponce',
                    id: 144,
                    regionBounds: null,
                    coordinates: [
                        { lng: -84.3686027, lat: 33.7817948 },
                        { lng: -84.3804575, lat: 33.7817865 },
                        { lng: -84.3854681, lat: 33.7818254 },
                        { lng: -84.3910791, lat: 33.7818108 },
                        { lng: -84.3900676, lat: 33.7712708 },
                        { lng: -84.3893238, lat: 33.768038 },
                        { lng: -84.3825723, lat: 33.7628072 },
                        { lng: -84.3793399, lat: 33.7587533 },
                        { lng: -84.3783388, lat: 33.7564108 },
                        { lng: -84.3786898, lat: 33.7533009 },
                        { lng: -84.380217, lat: 33.7513492 },
                        { lng: -84.3800058, lat: 33.7305906 },
                        { lng: -84.452797, lat: 33.7313261 },
                        { lng: -84.4531362, lat: 33.767834 },
                        { lng: -84.5181246, lat: 33.7424837 },
                        { lng: -84.5219484, lat: 33.5982962 },
                        { lng: -84.2795633, lat: 33.5962943 },
                        { lng: -84.2213887, lat: 33.6969044 },
                        { lng: -84.28868, lat: 33.7037593 },
                        { lng: -84.3309982, lat: 33.7743753 },
                        { lng: -84.3357068, lat: 33.7871586 },
                        { lng: -84.3405208, lat: 33.7959311 },
                        { lng: -84.3686027, lat: 33.7817948 }
                    ]
                },

                {
                    title: 'decatur',
                    id: 143,
                    regionBounds: null,
                    coordinates: [
                        { lng: -84.3309302, lat: 33.7744827 },
                        { lng: -84.2887015, lat: 33.7036791 },
                        { lng: -84.2214102, lat: 33.6968242 },
                        { lng: -84.1239067, lat: 33.8107186 },
                        { lng: -84.097861, lat: 33.871147 },
                        { lng: -84.1968064, lat: 33.8731206 },
                        { lng: -84.269934, lat: 33.8483174 },
                        { lng: -84.3068977, lat: 33.8429466 },
                        { lng: -84.3356556, lat: 33.8319304 },
                        { lng: -84.3588299, lat: 33.8209856 },
                        { lng: -84.3389158, lat: 33.8127154 },
                        { lng: -84.3405422, lat: 33.7958509 },
                        { lng: -84.3357282, lat: 33.7870784 },
                        { lng: -84.3309302, lat: 33.7744827 }
                    ]
                },

                {
                    title: 'west-midtown',
                    id: 141,
                    regionBounds: null,
                    coordinates: [
                        { lng: -84.4526974, lat: 33.8123231 },
                        { lng: -84.4200891, lat: 33.812019 },
                        { lng: -84.413566, lat: 33.8048872 },
                        { lng: -84.3981164, lat: 33.8006079 },
                        { lng: -84.3929592, lat: 33.7949208 },
                        { lng: -84.3912575, lat: 33.7882367 },
                        { lng: -84.3911006, lat: 33.7818019 },
                        { lng: -84.3904973, lat: 33.7752902 },
                        { lng: -84.3900891, lat: 33.7712619 },
                        { lng: -84.3893453, lat: 33.7680291 },
                        { lng: -84.4531577, lat: 33.7678251 },
                        { lng: -84.4526974, lat: 33.8123231 }
                    ]
                },

                {
                    title: 'avalon',
                    id: 846,
                    regionBounds: null,
                    coordinates: [{
                        lng: -84.1511496,
                        lat: 33.9942081
                    }, {
                        lng: -84.1253405,
                        lat: 34.1164682
                    }, {
                        lng: -84.0787645,
                        lat: 34.1685015
                    }, {
                        lng: -84.1022115,
                        lat: 34.2239424
                    }, {
                        lng: -84.4160078,
                        lat: 34.1168542
                    }, {
                        lng: -84.3727495,
                        lat: 34.0258501
                    }, {
                        lng: -84.331551,
                        lat: 33.9615195
                    }, {
                        lng: -84.2139865,
                        lat: 33.9870029
                    }, {
                        lng: -84.1511496,
                        lat: 33.9942081
                    }]
                },

                {
                    title: 'east-cobb',
                    id: 897,
                    regionBounds: null,
                    coordinates: [
                        { lng: -84.3544802, lat: 33.9554162 },
                        { lng: -84.331551, lat: 33.9615195 },
                        { lng: -84.3727495, lat: 34.0258501 },
                        { lng: -84.4160078, lat: 34.1168542 },
                        { lng: -84.6322655, lat: 34.0741998 },
                        { lng: -84.6696877, lat: 33.9518288 },
                        { lng: -84.566636, lat: 33.8570605 },
                        { lng: -84.5076853, lat: 33.8531251 },
                        { lng: -84.4816416, lat: 33.8579902 },
                        { lng: -84.4549061, lat: 33.8696919 },
                        { lng: -84.4421999, lat: 33.8841209 },
                        { lng: -84.4434814, lat: 33.9030286 },
                        { lng: -84.4076774, lat: 33.9168047 },
                        { lng: -84.4097373, lat: 33.9404486 },
                        { lng: -84.3544802, lat: 33.9554162 }
                    ]
                },

                {
                    title: 'chastain',
                    id: 135,
                    regionBounds: null,
                    coordinates: [
                        { lng: -84.3544802, lat: 33.9554162 },
                        { lng: -84.4097373, lat: 33.9404486 },
                        { lng: -84.4076774, lat: 33.9168047 },
                        { lng: -84.4434814, lat: 33.9030286 },
                        { lng: -84.4421999, lat: 33.8841209 },
                        { lng: -84.4549061, lat: 33.8696919 },
                        { lng: -84.4315566, lat: 33.8534045 },
                        { lng: -84.3975245, lat: 33.8432466 },
                        { lng: -84.3818614, lat: 33.85419 },
                        { lng: -84.3574843, lat: 33.8596412 },
                        { lng: -84.3525919, lat: 33.890747 },
                        { lng: -84.3544802, lat: 33.9554162 }
                    ]
                },

                {
                    title: 'athens',
                    id: 973,
                    regionBounds: null,
                    coordinates: [
                        { lng: -83.5911474, lat: 34.0499896 },
                        { lng: -83.5897741, lat: 33.8147006 },
                        { lng: -83.2402715, lat: 33.8169825 },
                        { lng: -83.2471379, lat: 34.0516964 },
                        { lng: -83.5911474, lat: 34.0499896 }
                    ]
                },

                {
                    title: 'downtown',
                    id: 950,
                    regionBounds: null,
                    coordinates: [
                        { lng: -84.4531577, lat: 33.7678251 },
                        { lng: -84.4528185, lat: 33.7313172 },
                        { lng: -84.3800273, lat: 33.7305817 },
                        { lng: -84.3801308, lat: 33.7515189 },
                        { lng: -84.3786036, lat: 33.7534706 },
                        { lng: -84.3783388, lat: 33.7564108 },
                        { lng: -84.3793614, lat: 33.7587444 },
                        { lng: -84.3825938, lat: 33.7627983 },
                        { lng: -84.3893453, lat: 33.7680291 },
                        { lng: -84.4531577, lat: 33.7678251 }
                    ]
                },

                {
                    title: 'buford',
                    id: 1239,
                    regionBounds: null,
                    coordinates: [{
                        lng: -84.0787645,
                        lat: 34.1685015
                    }, {
                        lng: -84.1253405,
                        lat: 34.1164682
                    }, {
                        lng: -84.1511496,
                        lat: 33.9942081
                    }, {
                        lng: -84.1082343,
                        lat: 33.9996162
                    }, {
                        lng: -84.1035491,
                        lat: 33.9647514
                    }, {
                        lng: -83.7640925,
                        lat: 33.9647769
                    }, {
                        lng: -83.7050406,
                        lat: 34.177501
                    }, {
                        lng: -83.8797931,
                        lat: 34.2921723
                    }, {
                        lng: -84.0202128,
                        lat: 34.2036277
                    }]
                }
            ]
        };
    },

    mounted() {
        document.querySelector('html, body').classList.add('overflow-hidden');
        this.animating = true;
        const tl = gsap.timeline();

        tl.set(this.$refs.title, { opacity: 0, y: '104%' })
            .set(this.$refs.text, { opacity: 0, y: '104%' })
            .set(this.$refs.input, { opacity: 0, y: '104%' })
            .set(this.$refs.button, { opacity: 0, y: '104%' })
            .set(this.$refs.bgWhite, { y: '-104%' })
            .set(this.$refs.bgYellow, { y: '-104%' })
            .set(this.$refs.closeButton, { opacity: 0 })
            .to(this.$refs.bgYellow, 0.6, { y: '0%', ease: Circ.easeInOut })
            .to(this.$refs.bgWhite, 0.6, { y: '0%', delay: -0.32, ease: Circ.easeInOut })
            .to(this.$refs.title, 0.6, { opacity: 1, y: '0%', delay: -0.4, ease: Power2.easeInOut })
            .to(this.$refs.text, 0.6, { opacity: 1, y: '0%', delay: -0.4, ease: Power2.easeInOut })
            .to(this.$refs.input, 0.6, { opacity: 1, y: '0%', delay: -0.4, ease: Power2.easeInOut })
            .to(this.$refs.button, 0.6, { opacity: 1, y: '0%', delay: -0.4, ease: Power2.easeInOut })
            .to(this.$refs.closeButton, 0.32, {
                opacity: 1,
                delay: -0.32,
                ease: Power1.easeOut,
                onComplete: () => {
                    this.animating = false;
                    this.setupRegions();
                }
            });
    },

    methods: {
        close() {
            if (!this.animating) {
                this.animating = true;

                const tl = gsap.timeline();

                tl.to(this.$refs.closeButton, 0.32, { opacity: 0, ease: Power1.easeOut });

                if (this.formReady) {
                    tl.to(this.$refs.form, 0.32, { opacity: 0, delay: -0.24, ease: Power1.easeOut });
                }

                tl.to(this.$refs.title, 0.6, { opacity: 0, y: '-104%', delay: -0.24, ease: Power2.easeInOut })
                    .to(this.$refs.text, 0.6, { opacity: 0, y: '-104%', delay: -0.4, ease: Power2.easeInOut })
                    .to(this.$refs.input, 0.6, { opacity: 0, y: '-104%', delay: -0.4, ease: Power2.easeInOut })
                    .to(this.$refs.button, 0.6, { opacity: 0, y: '-104%', delay: -0.4, ease: Power2.easeInOut })
                    .to(this.$refs.bgWhite, 0.6, { y: '104%', delay: -0.32, ease: Circ.easeInOut })
                    .to(this.$refs.bgYellow, 0.6, {
                        y: '104%',
                        delay: -0.32,
                        ease: Circ.easeInOut,
                        onComplete: () => {
                            this.animating = false;
                            $('.site-header').fadeIn();
                            document.querySelector('html, body').classList.remove('overflow-hidden');
                            this.$parent.started = false;
                        }
                    });
            }
        },

        setupRegions() {
            this.gustoRegions.forEach(region => {
                region.regionBounds = new google.maps.Polygon({ paths: region.coordinates });
            });
        },

        checkForm() {
            if (!this.eventAddress || !this.eventCity || !this.eventState || !this.eventZip) {
                this.errors = true;
            } else {
                this.errors = false;
            }

            if (!this.errors) {
                this.locateEvent();
            }
        },
        locateEvent() {
            const geocoder = new google.maps.Geocoder();
            this.addressFull = `${this.eventAddress}, ${this.eventCity}, ${this.eventState} ${this.eventZip}`;
            const address = this.addressFull.split(', ').join(',').split(' ').join('+');

            console.log(address);
            geocoder.geocode(
                {
                    address
                },
                (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        this.searchRegions(results[0].geometry.location);
                    } else {
                        console.log(`The address you entered could not be verified. Please try again.`);
                    }
                }
            );
        },

        searchRegions(address) {
            this.selectedRegion = null;
            const event = new google.maps.LatLng(address.lat(), address.lng());

            this.gustoRegions.forEach(region => {

                if (google.maps.geometry.poly.containsLocation(event, region.regionBounds)) {
                    console.log('region: ', region);
                    this.selectedRegion = region.id;
                }
            });

            if (this.selectedRegion) {
                $.ajax({
                    url: `/wp-json/wp/v2/locations/${this.selectedRegion}`
                }).done(store => {
                    console.log(`${store.title.rendered} region is where the event will be.`);

                    this.stageForm(store.acf.email);
                });
            } else {
                this.findClosestStore(address);
            }
        },

        toRad(x) {
            return (x * Math.PI) / 180;
        },

        checkDistance(coords1, coords2, isMiles) {
            const lon1 = coords1[1];
            const lat1 = coords1[0];

            const lon2 = coords2[1];
            const lat2 = coords2[0];

            const R = 6371; // km

            const x1 = lat2 - lat1;
            const dLat = this.toRad(x1);
            const x2 = lon2 - lon1;
            const dLon = this.toRad(x2);
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            let d = R * c;

            if (isMiles) d /= 1.60934;

            return d;
        },

        stageForm(emails) {
            this.updatedForm = `${this.typeform}/?email=${emails}&address=${this.addressFull}`;
            this.transitionForm();
        },

        findClosestStore(address) {
            const geolocatedAddress = [address.lat(), address.lng()];

            $.ajax({
                url: '/wp-json/wp/v2/locations'
            }).done(store => {
                let closestStoreIndex = 0;
                let closestDistance = 10000;

                for (let i = 0; i < store.length; i++) {
                    if (store[i].acf.geolocation) {
                        const distance = this.checkDistance(
                            geolocatedAddress,
                            [store[i].acf.geolocation.lat, store[i].acf.geolocation.lng],
                            true
                        );

                        if (distance < closestDistance) {
                            closestDistance = distance;
                            closestStoreIndex = i;
                        }
                    }
                }

                console.log(`${store[closestStoreIndex].title.rendered} is the closest store`);

                this.stageForm(store[closestStoreIndex].acf.email);
            });
        },

        transitionForm() {
            this.loadForm = true;
            this.animating = true;
            const tl = gsap.timeline();

            tl.set(this.$refs.cover, { y: '104%' })
                .to(this.$refs.cover, 0.6, {
                    y: '0%',
                    ease: Circ.easeInOut,
                    onComplete: () => {
                        this.formReady = true;
                    }
                })
                .to(this.$refs.cover, 0.6, {
                    y: '-104%',
                    delay: 0.56,
                    ease: Circ.easeInOut,
                    onComplete: () => {
                        this.animating = false;
                    }
                });
        }
    }
};
</script>
